module.exports = __webpack_public_path__ + "7b52be99a9fbab964835b04d44442db1.MP3";